import React from 'react';
import { Globe } from 'lucide-react';
import { useLanguage } from '../hooks/useLanguage';
export function LanguageToggle() {
  const {
    lang,
    toggleLang
  } = useLanguage();
  return <button onClick={toggleLang} className="fixed top-4 right-4 z-50 flex items-center gap-2 bg-white/10 backdrop-blur-md border border-white/20 text-white px-4 py-2 rounded-full shadow-lg hover:bg-white/20 transition-all duration-300 group" aria-label="Toggle language" data-id="element-136">
      <Globe className="w-4 h-4 text-brand-amber group-hover:rotate-12 transition-transform" data-id="element-137" />
      <span className="font-bold text-sm tracking-widest" data-id="element-138">
        <span className={lang === 'es' ? 'text-white' : 'text-white/50'} data-id="element-139">
          ES
        </span>
        <span className="mx-1 text-white/30" data-id="element-140">/</span>
        <span className={lang === 'en' ? 'text-white' : 'text-white/50'} data-id="element-141">
          EN
        </span>
      </span>
    </button>;
}